export default __webpack_public_path__ + "static/media/close_button.8b0db979.svg";